import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Col, Row, Button, Popover, Icon } from "antd";
import { withRouter } from "react-router-dom";
import "./MultiSelectorHeaderOptions.css";
import MultiDownloadModal from "./MultiDownloadModal";
import MultiShareModal from "./MultiShareModal";
import MultiDeleteModal from "./MultiDeleteModal";
import MultiMoveModal from "./MultiMoveModal";
import MultiBunkeyHostModal from "./MultiBunkeyHostModal";
import RightsAssignModal from "../rights-manager/RightsAssignModal";
import { cancelSelect, addAll } from "../../actions/MultiselectAction";
import {
  multiAddFavoriteAsset,
  multiRemoveFavoriteAsset
} from "../../actions/AssetsFavoritesAction";
import menuVertical from "../../assets/menu-vertical.svg";
import CloseIcon from "../../assets/close-icon.svg";
import { getBreadCrumbs, getNewPermission, canDeleteAsset } from "../../utils";
import { multipleOptionsIsDone } from "../../actions/ClientAction";

class MultiSelectorHeaderOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canMove: true,
      canShare: true,
      canAddToFavorites: true,
      canDownload: true,
      showModalMultiDownload: false,
      showModalMultiShare: false,
      showModalMultiDelete: false,
      showModalMultiMove: false,
      showModalMultiBunkeyHost: false,
      showModalRightsAssign: false,
      visibleOptions: false
    };
  }

  /**
   * ¿Puede borrarse TODA la selección?
   *
   * Antes esto era `canDelete: true` fijo en el state y nunca se recalculaba:
   * el botón de eliminar de la barra de multi-selección se le mostraba a
   * cualquiera, sin importar los permisos de su grupo. Se resuelve por asset y
   * con el permiso que corresponde a su tipo (`deleteFolder` para carpetas),
   * con el mismo criterio de canBunkeyHost: si el permiso individual lo niega,
   * la acción bulk no se ofrece.
   */
  canDelete() {
    const { newMatrix, user, selectedFiles } = this.props;

    if (!selectedFiles || !selectedFiles.length) return false;

    const isAdmin =
      !!user && (user.clientRole === "admin" || user.role === "admin");
    if (isAdmin) return true;

    return selectedFiles.every(asset => canDeleteAsset(asset, newMatrix));
  }

  // Mismo criterio que la vista de un asset (CollectionMiddleView), para que la
  // acción bulk no ofrezca algo que el permiso individual niega.
  canBunkeyHost() {
    const { modules, newMatrix, user, selectedFiles } = this.props;

    if (!selectedFiles || !selectedFiles.length) return false;

    const isAdmin =
      !!user && (user.clientRole === "admin" || user.role === "admin");

    const module = (modules || []).find(m => m.name === "BunkeyHost");
    if (!isAdmin && !(module && module.activate)) return false;
    if (isAdmin) return true;

    return selectedFiles.every(asset =>
      getNewPermission(asset._id, newMatrix, "bunkeyHost")
    );
  }

  // Las carpetas y búnkers entran a la asignación por lote igual que los
  // archivos: assignRightsMany las expande recursivamente en el backend, que es
  // el mismo camino que usa el Gestor. Antes se excluían acá y la barra no
  // ofrecía nada al seleccionar una carpeta (feedback de Ricardo, 2026-09-10).
  // `bunker` es una etiqueta que pone el front a las carpetas del root
  // (AssetsRootAction.js:96); en la base son `folder`, así que el backend las
  // expande sin cambios.
  canRightsAssign() {
    const { modules, newMatrix, user, selectedFiles } = this.props;
    const module = (modules || []).find(m => m.name === "useRights");
    const isAdmin =
      !!user && (user.clientRole === "admin" || user.role === "admin");
    return (
      !!selectedFiles &&
      selectedFiles.length > 0 &&
      !!module &&
      module.activate &&
      (isAdmin || selectedFiles.every(asset =>
        getNewPermission(asset._id, newMatrix, "editRightsDart")
      ))
    );
  }

  handleShowRightsAssign = () => {
    this.setState({ showModalRightsAssign: true, visibleOptions: false });
  };

  handleHiddenRightsAssign = () => {
    this.setState({ showModalRightsAssign: false });
  };

  handleRightsAssignDone = () => {
    this.setState({ showModalRightsAssign: false });
    // La asignación terminó correctamente: no conservar la selección que
    // abrió el modal ni sus checks visuales en la colección.
    this.handleCancelSelection();
  };

  handleShowModalMultiBunkeyHost = () => {
    this.setState({
      showModalMultiBunkeyHost: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiBunkeyHost = () => {
    this.setState({
      showModalMultiBunkeyHost: false
    });
  };

  handleShowModalMultiDownload = () => {
    this.setState({
      showModalMultiDownload: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiDownload = () => {
    this.setState({
      showModalMultiDownload: false
    });
  };

  handleShowModalMultiShare = () => {
    this.setState({
      showModalMultiShare: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiShare = () => {
    this.setState({
      showModalMultiShare: false
    });
  };

  handleShowModalMultiDelete = () => {
    this.setState({
      showModalMultiDelete: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiDelete = () => {
    this.setState({
      showModalMultiDelete: false
    });
  };

  handleShowModalMultiMove = () => {
    this.setState({
      showModalMultiMove: true,
      visibleOptions: false
    });
  };

  handleHiddenModalMultiMove = () => {
    this.setState({
      showModalMultiMove: false
    });
  };

  handleChangeVisibleOptions = value => {
    this.setState({
      visibleOptions: value
    });
  };

  handleCancelSelection = () => {
    const { keyCollection, cancelSelect, multipleOptionsIsDone } = this.props;
    // selectedFiles.data y los flags isCheckMultiple viven en estados
    // distintos. Cancelar debe limpiar ambos en la misma interacción.
    cancelSelect();
    multipleOptionsIsDone(keyCollection);
  };

  allFavorite(array) {
    for (let i = 0; i < array.length; i++) {
      if (!array[i].isFavorite) {
        return false;
      }
    }
    return true;
  }

  handleAddFavorites = () => {
    const {
      selectedFiles,
      favoriteAssets,
      multiAddFavoriteAsset,
      multiRemoveFavoriteAsset,
      workclient,
      workspace,
      intl
    } = this.props;
    const favoritesIds = favoriteAssets.map(e => e._id);
    const filesToUpdate = selectedFiles.map(e => {
      const isFavorite = favoritesIds.includes(e._id);
      return {
        ...e,
        isFavorite: isFavorite
      };
    });
    const isAllFavorite = this.allFavorite(filesToUpdate);

    if (isAllFavorite) {
      multiRemoveFavoriteAsset(workclient, workspace, filesToUpdate, intl);
    } else {
      multiAddFavoriteAsset(workclient, workspace, filesToUpdate, intl);
    }
  };

  componentDidUpdate(prevProps) {
    const { isFetching, isMoving, error, sended } = this.props;
    const {
      isFetching: isFetchingOld,
      isMoving: isMovingOld,
      sended: sendedOld
    } = prevProps;
    if (isFetchingOld && !isFetching && !error) {
      if (this.state.showModalMultiDelete) {
        this.handleCancelSelection();
        this.handleHiddenModalMultiDelete();
      }
    }
    if (isMovingOld && !isMoving && !error) {
      if (this.state.showModalMultiMove) {
        this.handleCancelSelection();
        this.handleHiddenModalMultiMove();
      }
    }
    if (!sendedOld && sended) {
      this.handleCancelSelection();
      this.handleHiddenModalMultiShare();
    }
  }

  render() {
    const {
      selectedFiles,
      intl,
      addAll,
      currentFiles,
      keyCollection,
      isFetching,
      isMoving,
      folderselect,
      newColor
    } = this.props;
    const {
      canMove,
      canShare,
      canAddToFavorites,
      canDownload,
      showModalMultiDownload,
      showModalMultiShare,
      showModalMultiDelete,
      showModalMultiMove,
      showModalMultiBunkeyHost,
      showModalRightsAssign,
      visibleOptions
    } = this.state;

    const breadcrumbState = getBreadCrumbs(folderselect);
    const folderName = [...breadcrumbState].pop();

    return (
      <>
        {selectedFiles && selectedFiles.length > 0 && (
          <div className="multiselector-container" style={{ width: "100%" }}>
            <div className={"container"}>
              <Row
                type={"flex"}
                justify={"space-between"}
                align={"middle"}
                style={{ height: "100%" }}
              >
                <Col span={22}>
                  <span
                    style={{
                      marginRight: 17,
                      color: newColor,
                      fontSize: 15,
                      fontWeight: 600
                    }}
                  >
                    <img
                      src={CloseIcon}
                      alt="icon file void"
                      style={{
                        marginRight: 10,
                        width: 20,
                        height: 20,
                        cursor: "pointer"
                      }}
                      onClick={this.handleCancelSelection}
                    />
                    {intl.formatMessage({ id: "multi-share-selected" })}{" "}
                    {selectedFiles ? selectedFiles.length : 0}{" "}
                    {`${
                      selectedFiles && selectedFiles.length === 1
                        ? intl.formatMessage({
                            id: "multi-share-selected-item"
                          })
                        : intl.formatMessage({
                            id: "multi-share-selected-items"
                          })
                    }`}
                  </span>
                  <div className="multi-visible-actions">
                    {/* Todas iguales: sólo texto, sin que ninguna lleve un icono
                        suelto ni quede destacada. "Descargar" era la única con
                        una flecha "↓" pegada al texto, y "Asignar derechos de
                        uso" la única con recuadro azul. Agregar a Favoritos
                        estaba sólo en el combo y ahora también acá, así que las
                        dos listas ofrecen lo mismo. */}
                    {canDownload && <button className="multi-action" type="button" onClick={this.handleShowModalMultiDownload}>{intl.formatMessage({ id: "downloads" })}</button>}
                    {canMove && <button className="multi-action" type="button" onClick={this.handleShowModalMultiMove}>{intl.formatMessage({ id: "move_asset" })}</button>}
                    {canShare && <button className="multi-action" type="button" onClick={this.handleShowModalMultiShare}>{intl.formatMessage({ id: "shared_share" })}</button>}
                    {canAddToFavorites && <button className="multi-action" type="button" onClick={this.handleAddFavorites}>{intl.formatMessage({ id: "add_to_favorites" })}</button>}
                    {this.canRightsAssign() && <button className="multi-action" type="button" onClick={this.handleShowRightsAssign}>{intl.formatMessage({ id: "rights_manager_assign_action" })}</button>}
                    {this.canDelete() && <button className="multi-action danger" type="button" onClick={this.handleShowModalMultiDelete}>{intl.formatMessage({ id: "delete_asset" })}</button>}
                  </div>
                  <Button
                    shape={"round"}
                    type={"primary"}
                    size={"small"}
                    style={{
                      marginRight: 17,
                      backgroundColor: newColor,
                      borderColor: newColor
                    }}
                    onClick={() => {
                      this.handleCancelSelection();
                    }}
                  >
                    {intl.formatMessage({ id: "cancel_button" })}
                  </Button>
                  <Button
                    shape={"round"}
                    type={"primary"}
                    size={"small"}
                    style={{ backgroundColor: newColor, borderColor: newColor }}
                    onClick={() => {
                      addAll(currentFiles, keyCollection);
                    }}
                  >
                    {intl.formatMessage({ id: "select_all" })}
                  </Button>
                </Col>
                {/* <Col xs={4} sm={4} md={8}> */}
                <Col span={2}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "end"
                    }}
                  >
                    <Popover
                      onVisibleChange={this.handleChangeVisibleOptions}
                      id={"menu-options-multi-selector"}
                      placement={"bottomRight"}
                      visible={visibleOptions}
                      content={
                        <ul>
                          {canDownload && (
                            <li onClick={this.handleShowModalMultiDownload}>
                              <Icon type="download" />{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "downloads" })}
                              </span>
                            </li>
                          )}
                          {this.canDelete() && (
                            <li onClick={this.handleShowModalMultiDelete}>
                              <Icon type="delete" />{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "delete_asset" })}
                              </span>
                            </li>
                          )}
                          {canShare && (
                            <li onClick={this.handleShowModalMultiShare}>
                              <Icon type="share-alt" />{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "shared_share" })}
                              </span>
                            </li>
                          )}
                          {/* "Insertar galería" queda fuera del menú de selección
                              múltiple por pedido de Producto (2026-09-10). El modal y
                              canBunkeyHost() se dejan en su lugar: la funcionalidad se
                              oculta, no se elimina, y sigue disponible desde la vista
                              individual del asset. */}
                          {this.canRightsAssign() && (
                            <li onClick={this.handleShowRightsAssign}>
                              <Icon type="safety-certificate" />{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "rights_manager_assign_action" })}
                              </span>
                            </li>
                          )}
                          {canAddToFavorites && (
                            <li onClick={this.handleAddFavorites}>
                              <Icon type="heart" />{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "add_to_favorites" })}
                              </span>
                            </li>
                          )}
                          {canMove && (
                            <li onClick={this.handleShowModalMultiMove}>
                              <Icon type="export" />{" "}
                              <span style={{ marginLeft: 5 }}>
                                {intl.formatMessage({ id: "move_asset" })}
                              </span>
                            </li>
                          )}
                        </ul>
                      }
                    >
                      <img
                        src={menuVertical}
                        alt="menu"
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: 50
                        }}
                      />
                    </Popover>
                  </div>
                </Col>
              </Row>
            </div>

            {showModalMultiDownload && (
              <MultiDownloadModal
                showModal={showModalMultiDownload}
                handleHiddenModal={this.handleHiddenModalMultiDownload}
                keyCollection={keyCollection}
              />
            )}

            {showModalMultiShare && (
              <MultiShareModal
                showModal={showModalMultiShare}
                handleHiddenModal={this.handleHiddenModalMultiShare}
                keyCollection={keyCollection}
                selectedFiles={selectedFiles}
              />
            )}

            {showModalMultiDelete && (
              <MultiDeleteModal
                showModal={showModalMultiDelete}
                handleHiddenModal={this.handleHiddenModalMultiDelete}
                keyCollection={keyCollection}
                isFetching={isFetching}
                folderName={folderName ? folderName.name : ""}
              />
            )}

            {showModalMultiMove && (
              <MultiMoveModal
                showModal={showModalMultiMove}
                handleHiddenModal={this.handleHiddenModalMultiMove}
                keyCollection={keyCollection}
                isMoving={isMoving}
              />
            )}

            {showModalMultiBunkeyHost && (
              <MultiBunkeyHostModal
                showModal={showModalMultiBunkeyHost}
                handleHiddenModal={this.handleHiddenModalMultiBunkeyHost}
              />
            )}

            {showModalRightsAssign && (
              <RightsAssignModal
                visible={showModalRightsAssign}
                onClose={this.handleHiddenRightsAssign}
                onDone={this.handleRightsAssignDone}
                selection={selectedFiles.map(data => ({
                  kind:
                    data.type === "folder" || data.type === "bunker"
                      ? "folder"
                      : "file",
                  data
                }))}
                workclient={this.props.workclient}
                userId={this.props.user && this.props.user._id}
              />
            )}
          </div>
        )}
        {selectedFiles && selectedFiles.length > 0 && (
          <div
            style={{
              width: "100%",
              height: 100
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  const { keyCollection } = state.selectedFiles;

  let object;

  switch (keyCollection) {
    case "assetsRoot":
      object = {
        isFetching: state.assetsRoot.isFetching,
        isMoving: state.assetsRoot.isMoving,
        error: state.assetsRoot.error,
        currentFiles: state.assetsRoot.data,
        folderselect: state.assetsRoot.folderselect
      };
      break;
    case "assetsLastUploads":
      object = {
        isFetching: state.assetsLastUploads.isFetching,
        isMoving: state.assetsLastUploads.isMoving,
        error: state.assetsLastUploads.error,
        currentFiles: state.assetsLastUploads.data,
        folderselect: state.assetsLastUploads.folderselect
      };
      break;
    case "assetsShared":
      object = {
        isFetching: state.assetsShared.isFetching,
        isMoving: state.assetsShared.isMoving,
        error: state.assetsShared.error,
        currentFiles: state.assetsShared.data,
        folderselect: state.assetsShared.folderselect
      };
      break;
    case "assetsFavorites":
      object = {
        isFetching: state.assetsFavorites.isFetching,
        isMoving: state.assetsFavorites.isMoving,
        error: state.assetsFavorites.error,
        currentFiles: state.assetsFavorites.data,
        folderselect: state.assetsFavorites.folderselect
      };
      break;
    case "assetsExplore":
      object = {
        isFetching: state.assetsExplore.isFetching,
        isMoving: state.assetsExplore.isMoving,
        error: state.assetsExplore.error,
        currentFiles: state.assetsExplore.data,
        folderselect: state.assetsExplore.folderselect
      };
      break;
    case "searcher":
      object = {
        isFetching: state.searcher.isFetching,
        isMoving: state.searcher.isMoving,
        error: state.searcher.error,
        currentFiles: state.searcher.data,
        folderselect: state.searcher.folderselect
      };
      break;

    default:
      object = {};
      break;
  }
  return {
    ...object,
    workclient: state.client.workclient,
    selectedFiles: state.selectedFiles.data,
    keyCollection: state.selectedFiles.keyCollection,
    modules: state.client.data ? state.client.data.modules : [],
    newMatrix: state.group.newMatrix,
    user: state.authUser.user,
    favoriteAssets: state.assetsFavorites.data,
    workspace: state.assetsFavorites.workspace,
    sended: state.assetsShared.sended,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF"
  };
};

const mapDispatchToProps = {
  cancelSelect,
  addAll,
  multipleOptionsIsDone,
  multiAddFavoriteAsset,
  multiRemoveFavoriteAsset
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MultiSelectorHeaderOptions)
  )
);
